import * as React from 'react';
import { createSvgIcon } from '..';
export var ChevronLeft = createSvgIcon({
    LeftToRight: (React.createElement(React.Fragment, null,
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M11 1L4 8l7 7" }))),
}, 'small');
//# sourceMappingURL=ChevronLeft.js.map